var youbora = require('youboralib')
var manifest = require('../manifest.json')

youbora.adapters.ViaccessOrca = youbora.StandardAdapter.extend({
  /** Override to return current plugin version */
  getVersion: function () {
    return manifest.version + '-' + manifest.name + '-' + manifest.tech
  },

  /** Override to return current playhead of the video */
  getPlayhead: function () {
    return this.player.currentTime
  },

  /** Override to return current playrate */
  getPlayrate: function () {
    if (this.flags.isPaused) return 0
    return this.player.videoElement.playbackRate || 1
  },

  /** Override to return dropped frames since start */
  getDroppedFrames: function () {
    return this.player.videoElement.webkitDroppedFrameCount
  },

  /** Override to return video duration */
  getDuration: function () {
    return this.player.duration
  },

  /** Override to return current bitrate */
  getBitrate: function () {
    if (this.player.quality >= 0 && this.player.qualities && this.player.qualities.length) {
      var quality = this.player.qualities[this.player.quality]
      return quality.bitrate || quality.bandwidth
    }
    return null
  },

  /** Override to return rendition */
  getRendition: function () {
    if (this.player.quality >= 0 && this.player.qualities && this.player.qualities.length) {
      var quality = this.player.qualities[this.player.quality]
      var width = quality.width
      var height = quality.height
      if (!width || !height) {
        width = this.player.videoElement.videoWidth
        height = this.player.videoElement.videoHeight
      }
      return youbora.Util.buildRenditionString(width, height, quality.bitrate || quality.bandwidth)
    }
    return null
  },

  /** Override to return title */
  getTitle: function () {
    return this.player.videoElement.title || "Unknown"
  },

  /** Override to recurn true if live and false if VOD */
  getIsLive: function () {
    return this.player.isLive
  },

  /** Override to return resource URL. */
  getResource: function () {
    var playerId = this.player.currentPlayer_
    if (playerId) {
      if (playerId == 0) {
        return this.player.hlsPlayer_ ? this.player.hlsPlayer_.url : null
      }
      if (playerID == 1) {
        return this.player.dashPlayer_ ? this.player.dashPlayer_.getManifestUri() : null
      }
    }
    if (this.player.videoElement && this.player.videoElement.src) {
      return this.player.videoElement.src
    }
    return null
  },

  /** Override to return player version */
  getPlayerVersion: function () {
    return this.player.version
  },

  /** Override to return player's name */
  getPlayerName: function () {
    return "Viaccess Orca"
  },

  initializeAdapter: function () {
    // Enable playhead monitor (buffer = true, seek = false)
    this.monitorPlayhead(true, false)
  },

  /** Register listeners to this.player. */
  getListenersList: function () {
    return [{
      events: {
        'play': this.playListener,
        'pause': this.pauseListener,
        'playing': this.playingListener,
        'error': this.errorListener,
        'seeking': this.seekingListener,
        'seeked': this.seekedListener,
        'ended': this.endedListener,
        'abort': this.endedListener,
        'buffering': this.joinListener,
        'timeupdate': this.timeupdateListener,
        'trackschanged': this.endedListener
      }
    }]
  },

  /** Listener for 'play' event. */
  playListener: function () {
    this.fireStart()
    this.fireResume()
  },

  /** Listener for 'pause' event. */
  pauseListener: function () {
    if (this.player.videoElement.ended) {
      this.fireStop()
    }
    this.firePause()
  },

  /** Listener for 'playing' event. */
  playingListener: function () {
    this.fireResume()
    if (this.getPlayhead() > 0) {
      this.fireJoin()
    }
  },

  joinListener: function () {
    if (this.getPlayhead() > 0) {
      this.fireJoin()
    }
  },

  /** Listener for 'error' event. */
  errorListener: function (e) {
    this.fireError(e.data.code, e.data.message)
    this.fireStop()
  },

  /** Listener for 'seeking' event. */
  seekingListener: function () {
    this.fireSeekBegin()
  },

  /** Listener for 'seeked' event. */
  seekedListener: function () {
    this.fireSeekEnd()
  },

  /** Listener for 'ended' event. */
  endedListener: function () {
    this.fireStop()
  },

  timeupdateListener: function () {
    if (this.getPlayhead() > 0.1) {
      this.fireJoin()
    }
  }
})

module.exports = youbora.adapters.ViaccessOrca
